import {MONTHS} from "./variables";
import {
    getBooleanField,
    getNumberField,
    getPercentageField,
    getTextField,
    getTextFieldWithCommand
} from "../components/Home/Map/MapSideDrawer";

export const letterSpace = (str) =>
    str
        .split("")
        .map((s) => (/[A-Z]/.test(s) ? ` ${s.toLowerCase()}` : s))
        .join("");

export const getDeviceLocation = () => {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            position => resolve(position.coords),
            error => reject(error)
        )
    })
}
export const groupBy = (array, key) => {
    return array.reduce((prevValue, currValue) => {
        if (!(currValue[key] in prevValue))
            prevValue[currValue[key]] = [];
        prevValue[currValue[key]].push(currValue);
        return prevValue;
    }, {});
}
export const timeStampToTimeString = (timeValue) => {
    const date = new Date(timeValue);
    const day = date.getDate();
    const month = MONTHS[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const datetimeString = `${day}. ${month} ${year}, ${hours < 10 ? 0 : ""}${hours}:${minutes < 10 ? 0 : ""}${minutes}:${seconds < 10 ? 0 : ""}${seconds}`;
    return datetimeString;
}
export const getLocationParametersView = (parameters) => {
    return parameters.map((item, counter) => {
        const {pipe, name} = item;
        if (name === "online") return "";
        if (pipe === "number") {
            return getNumberField(item);
        } else if (pipe === "boolean") {
            return getBooleanField(item);
        } else if (pipe === "percent") {
            return getPercentageField(item);
        } else {
            if (item?.type === "COMMAND") {
                return getTextFieldWithCommand(item)
            } else {
                return getTextField(item)
            }
        }
    })
}
export const formatLatLng = (value) => {
    try {
        return parseFloat(value).toFixed(5);
    } catch (err) {
        return value;
    }
}